const reducers = (state, { type, data }) => {
  switch (type) {
    case 'OPEN_CART':
      return {
        ...state,
        cartOpen: true,
      }
    case 'CLOSE_CART':
      return {
        ...state,
        cartOpen: false,
      }
    case 'OPEN_SEARCH':
      return {
        ...state,
        searchOpen: true,
      }
    case 'CLOSE_SEARCH':
      return {
        ...state,
        searchOpen: false,
      }
    case 'OPEN_SIZE_WIZARD':
      return {
        ...state,
        sizeWizardOpen: true,
      }
    case 'CLOSE_SIZE_WIZARD':
      return {
        ...state,
        sizeWizardOpen: false,
      }
    case 'OPEN_ASIDE':
      return {
        ...state,
        asideOpen: true,
      }
    case 'CLOSE_ASIDE':
      return {
        ...state,
        asideOpen: false,
      }
    case 'UPDATE_CURRENCY':
      return {
        ...state,
        currency: data,
      }
    case 'UPDATE_CURRENCY_POPIN':
      return {
        ...state,
        currencyPopIn: data,
      }
    case 'SET_CURRENCY_WITH_POPIN':
      let { currency, currencyPopIn } = data
      return {
        ...state,
        currency,
        currencyPopIn,
      }
    case 'SELECT_STORE':
      return {
        ...state,
        storeSubdomain: data,
      }
    case 'REPLACE_CHECKOUT':
      return {
        ...state,
        checkouts: {
          ...state.checkouts,
          [data.storeSubdomain]: data,
        },
      }
    case 'SET_NODE_LOCALE':
      return {
        ...state,
        nodeLocale: data,
      }
    case 'SET_SIZE_VARIANT':
      return {
        ...state,
        sizeVariants: data,
      }
    case 'REPLACE_SIZE_VARIANT':
      return {
        ...state,
        sizeVariants: data,
      }
    default:
      return console.log('no action')
  }
}

export default reducers
